module.exports = __webpack_public_path__ + "img/details-one.336c4ed7.png";